import { render } from "./homePcIndex.vue?vue&type=template&id=361547b1"
import script from "./homePcIndex.vue?vue&type=script&lang=js"
export * from "./homePcIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__